import { BaseResource } from 'utils/ApiUtils';


export default class SysUser extends BaseResource {
  constructor(args) {
    super(args, SysUser.attributes);
  };

  static columns = [
    { title: "SystemUserId", field: "SystemUserId", type: "string", hidden: true },
    { title: "Name", field: "Name", type: "string" },
    { title: "Email", field: "Email", type: "string" },
    { title: "Username", field: "UserName", type: "string" },
    { title: "Role", field: "Description_SystemRole", type: "string" },
    { title: "Alternate Email", field: "AlternativeEmail", type: "string" },
    { title: "SystemRoleId", field: "SystemRoleId", type: "string", hidden: true },
    { title: "Inspector Number", field: "InspectorNumber", type: "string" },
    { title: "DeviceType", field: "DeviceType_SyncLogging", type: "string", filter: false, sorting: false },
    { title: "AppVersion", field: "AppVersion_SyncLogging", type: "string", filter: false, sorting: false },
    { title: "Timestamp", field: "Timestamp_SyncLogging", type: "date", filter: false, sorting: false },
 
  ];

  static attributes = SysUser.columns.map(r => r.field);

  static expand = [{
    SystemRole: {
      select: ["Description"]
    },
    SyncLogging: {
      select: ["JobId", "DeviceType", "AppVersion", "Timestamp", "UserName"],
      orderBy:  "Timestamp desc" ,
      top: 1
    }
  }]

}
